import { Link } from "react-router-dom";

const values = [
  { icon: "ri-leaf-fill", title: "收录要全", desc: "坚持构建完整书库，热门连载与冷门完结都不遗漏，让海量资源真正做到全站覆盖。" },
  { icon: "ri-refresh-fill", title: "更新要快", desc: "热门作品每日同步最新章节，确保你追更的作品永远有最新的那一话。" },
  { icon: "ri-search-eye-line", title: "定位要准", desc: "清晰的全库分类与标签体系，帮你从万千作品中快速定位到想看的漫画。" },
  { icon: "ri-heart-3-fill", title: "体验要好", desc: "响应式阅读界面，手机电脑都能畅快阅读，尊重每一位读者的阅读习惯。" },
];

const principles = [
  { step: "01", title: "聚合全站资源", desc: "整合全站漫画总目录，覆盖多元题材，构建一站式的找漫入口。" },
  { step: "02", title: "智能分类导航", desc: "40+ 细分类目与标签体系，结合搜索，让定位作品快人一步。" },
  { step: "03", title: "持续更新完善", desc: "全库完整书库持续补充，评分与推荐不断优化，越用越好用。" },
];

export default function About() {
  return (
    <div className="pt-16">
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-4 md:px-6">
          <nav className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600" aria-label="面包屑导航">
            <Link to="/" className="transition-colors hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            <span className="font-medium text-foreground-950">关于我们</span>
          </nav>
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-4 py-12 md:px-6 md:py-16">
        {/* Brand intro */}
        <section className="text-center">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-book-open-fill"></i> 关于天堂漫画
          </span>
          <h1 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">为每一份热爱阅读的心，建一座天堂</h1>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-foreground-600">
            天堂漫画是一个专注聚合漫画资源的在线阅读平台。我们深知，找到一部对味的漫画、追上一条热门的连载，往往要辗转多个网站、反复搜索。于是我们决定，把全站漫画海量资源聚合到一处，搭建一个「全库完整书库」，让所有热爱漫画的人，都能在这里一站找全、安心追更。
          </p>
        </section>

        {/* Positioning */}
        <section className="mt-14 grid grid-cols-1 gap-4 rounded-3xl border border-background-200 bg-background-100 p-6 md:grid-cols-3 md:p-8">
          {values.map((v) => (
            <div key={v.title} className="rounded-2xl bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-2xl text-primary-600">
                <i className={v.icon}></i>
              </span>
              <h2 className="mt-3 font-heading text-base font-bold text-foreground-950">{v.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
            </div>
          ))}
        </section>

        {/* Principles */}
        <section className="mt-16">
          <div className="text-center">
            <span className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-road-map-line"></i> 发展理念
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950">我们如何把书库越建越好</h2>
          </div>
          <div className="mt-8 space-y-4">
            {principles.map((p, i) => (
              <div key={p.step} className={`flex flex-col gap-4 rounded-2xl border border-background-200 bg-background-50 p-6 sm:flex-row sm:items-center ${i % 2 === 0 ? "" : "sm:flex-row-reverse"}`}>
                <span className="shrink-0 font-heading text-4xl font-black text-primary-200">{p.step}</span>
                <div>
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Reputation */}
        <section className="mt-16 rounded-3xl bg-primary-600 px-6 py-12 text-center md:px-12">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50">
            <i className="ri-chat-quote-fill"></i> 用户口碑
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black text-background-50">千万读者的共同选择</h2>
          <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-4 text-left sm:grid-cols-3">
            <div className="rounded-2xl bg-background-50/10 p-5">
              <p className="text-sm leading-relaxed text-background-50">「找冷门老漫画再也不用几个站来回切，全库真的太全了。」</p>
              <p className="mt-3 text-xs text-background-100">—— 热血迷 · 夜风残</p>
            </div>
            <div className="rounded-2xl bg-background-50/10 p-5">
              <p className="text-sm leading-relaxed text-background-50">「更新特别快，追的连载每天都能看到最新话，太香了。」</p>
              <p className="mt-3 text-xs text-background-100">—— 甜宠党 · 奶茶三分甜</p>
            </div>
            <div className="rounded-2xl bg-background-50/10 p-5">
              <p className="text-sm leading-relaxed text-background-50">「分类和评分都靠谱，按推荐找的作品基本没踩过雷。」</p>
              <p className="mt-3 text-xs text-background-100">—— 推理迷 · 老侦探</p>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="mt-14 text-center">
          <h2 className="font-heading text-xl font-black text-foreground-950">想了解更多？欢迎联系我们</h2>
          <p className="mt-3 text-sm text-foreground-600">有任何建议或想法，都可以通过反馈告诉我们，帮助天堂漫画变得更好。</p>
          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link to="/contact" className="w-full whitespace-nowrap rounded-full bg-primary-500 px-8 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto">
              联系我们
            </Link>
            <Link to="/faq" className="w-full whitespace-nowrap rounded-full border border-background-300 px-8 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 sm:w-auto">
              查看常见问题
            </Link>
          </div>
        </section>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于天堂漫画",
            url: "https://hellomanga.github.io/about",
            description: "天堂漫画聚合全站漫画资源，构建完整书库，帮助读者一站式找到并追更心仪的漫画作品。",
          }),
        }}
      />
    </div>
  );
}